import Vue from "vue";
import gaService from "./ga.service";

export default {
    async openSession(options = { lang: "en", gameId }) {
        gaService.send("games", "mascot", options.gameId);
        return (await Vue.http.post("/api/mascot/session/open", Object.assign({}, options))).data;
    },
    async openDemoSession(options = { lang: "en", gameId }) {
        gaService.send("games", "mascot", options.gameId);
        return (await Vue.http.post("/api/mascot/session/opendemo", Object.assign({}, options))).data;
    },
    async closeSession() {
        return (await Vue.http.post("/api/mascot/session/close")).data;
    }
};


// WEBPACK FOOTER //
// ./_common/services/mascot.service.js